/**
 * Fetches the transaction ID from a tracking URL.
 *
 * @param {object} params - Parameters for the tracking URL.
 * @param {string} params.affId2 - Affiliate ID 2.
 * @param {string} params.oid2 - Offer ID 2.
 * @param {string} params.sourceId - Source ID.
 * @param {string} params.sub1 - Sub ID 1.
 * @param {string} params.sub2 - Sub ID 2.
 * @param {string} params.sub3 - Sub ID 3.
 * @param {string} params.sub4 - Sub ID 4.
 * @param {string} params.sub5 - Sub ID 5.
 * @param {string} params.utmCampaign - UTM campaign identifier.
 * @returns {Promise<string>} The transaction ID.
 * @throws {Error} If the fetch request fails or the response is invalid.
 */
export async function getTrid({
  affId2,
  oid2,
  sourceId,
  sub1,
  sub2,
  sub3,
  sub4,
  sub5,
  utmCampaign,
}) {
  const url = `https://www.ab92trk.com/clk?nid=809&oid=19&affid=${utmCampaign}&sub1=${sub1}&sub2=${sub2}&sub3=${sub3}&sub4=${sub4}&sub5=${sub5}&source_id=${sourceId}&oid2=${oid2}&affid2=${affId2}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Failed to fetch transaction ID: ${response.statusText}`)
  }

  const data = await response.json()

  if (!data || !data.transaction_id) {
    throw new Error('Invalid response format: transaction ID is missing')
  }

  return data.transaction_id
}
